export { default as addIdToFilename } from './addIdToFilename';
export { default as removeIdFromFilename } from './removeIdFromFilename';
export { default as addInheritedFields } from './addInheritedFields';
export { default as axiosAPI } from './axiosAPI';
export { default as addFieldFromDeepValue } from './addFieldFromDeepValue';
export { default as CustomError } from './CustomError';
export { default as customFetchData } from './customFetchData';
export { default as checkPermissions } from './checkPermissions';
export { default as convert } from './convert';
export { default as dream } from './dream';
export { default as formatDate } from './formatDate';
export { default as filterActivities } from './filterActivities';
export { default as deleteInheritedFields } from './deleteInheritedFields';
export { default as generateNumber } from './generateNumber';
export { default as getSorting } from './getSorting';
export { default as getFileByUrl } from './getFileByUrl';
export { default as getSignedUrl } from './getSignedUrl';
export { default as getStudentsByTeacherAndProduct } from './getStudentsByTeacherAndProduct';
export { default as getStudentsByTeacher } from './getStudentsByTeacher';
export { default as getTranslateFunc } from './getTranslateFunc';
export { default as getName } from './getName';
export { default as getReps } from './getReps';
export { default as getPageTitle } from './getPageTitle';
export { default as getGroupElements } from './getGroupElements';
export { default as inputNumberLimit } from './inputNumberLimit';
export { default as mobileAndTabletCheck } from './mobileAndTabletCheck';
export { default as muiTheme } from './muiTheme';
export { default as removeParenthesis } from './removeParenthesis';
export { default as renderRoutes } from './renderRoutes';
export { default as Scope } from './Scope';
export { default as redirect } from './redirect';
export { default as setAuthToken } from './setAuthToken';
export { default as withLoading } from './withLoading';
export { default as prepareButtons } from './prepareButtons';
export { default as formatHtmlForPlay } from './formatHtmlForPlay';
export { default as msToHMS } from './msToHMS';
export { default as msToDuration } from './msToDuration';
export { default as calculateReports } from './calculateReports';
export { default as formatLocalesToOptions } from './formatLocalesToOptions';
export { default as printElem } from './printElem';
export { default as getScale } from './getScale';
export { default as responseHandler } from './responseHandler';
export { default as parseQueryString } from './parseQueryString';
export { default as makeOptions } from './make-options';
export { default as extractContent } from './extractContent';
export { default as isUsingStrings } from './isUsingStrings';

export { default as checkTeam } from './checkTeam';

// Components
export { default as CustomRoute } from './CustomRoute';
export { default as MaterialFaIcon } from './MaterialFaIcon';
export { default as NeedPermissions } from './NeedPermissions';
export { default as RecordAudio } from './RecordAudio';
export { default as Translate } from './Translate';

export const shouldShowMyAccount = ({ purchaseProductType, fullyPaid, freeTrialWeeks }) => {
  const normalizedFullyPaid = Boolean(fullyPaid);
  const hasFreeTrial = Number(freeTrialWeeks || 0) > 0;

  const result =
    purchaseProductType === 'subscription' ||
    purchaseProductType === 'org_subscription' ||
    hasFreeTrial;

  console.log('[shouldShowMyAccount]', {
    purchaseProductType,
    fullyPaid: normalizedFullyPaid,
    freeTrialWeeks: Number(freeTrialWeeks || 0),
    result,
  });

  return result;
};